// Import all translation modules
import { common } from './common';
import { auth } from './auth';
import { homepage } from './homepage';
import { cars as carsModule } from './cars';
import { customer } from './customer';
import { agency } from './agency';
import { admin } from './admin';
import { dashboard } from './dashboard';
import { vehicles } from './vehicles';
import { calendar } from './calendar';
import { privacy } from './privacy';

// Create bookings translations
export const bookings = {
  title: 'Bookings',
  subtitle: 'Manage your rental bookings',
  newBooking: 'New Booking',
  editBooking: 'Edit Booking',
  customer: 'Customer',
  selectCustomer: 'Select Customer',
  createNewCustomer: 'Create New Customer',
  searchCustomer: 'Search by name or national ID...',
  vehicle: 'Vehicle',
  selectVehicle: 'Select Vehicle',
  startDate: 'Start Date',
  endDate: 'End Date',
  pickupTime: 'Pickup Time',
  returnTime: 'Return Time',
  depositAmount: 'Deposit Amount',
  totalPrice: 'Total Price',
  notes: 'Notes',
  days: 'days',
  edit: 'Edit',
  allStatuses: 'All Statuses',
  totalBookings: '{{count}} booking(s)',
  noBookingsFound: 'No bookings found',
  noBookings: 'No bookings yet',
  tryDifferentFilter: 'Try adjusting your search or filters',
  noBookingsDesc: 'Start by creating your first booking',
  createFirstBooking: 'Create First Booking',
  status: {
    pending: 'Pending',
    confirmed: 'Confirmed',
    completed: 'Completed',
    cancelled: 'Cancelled'
  }
};

// Export organized English translations
export const en = {
  translation: {
    ...common,
    auth,
    homepage,
    cars: carsModule,
    carsPage: carsModule,
    customer,
    agency,
    admin,
    dashboard,
    vehicles,
    calendar,
    bookings,
    privacy,
    
    // Override to fix naming conflict - preserve navigation keys from common
    dashboardNav: 'Dashboard',
    
    // Properly nest common translations under 'common' key
    common: {
      ...common,
      // Legacy keys for backward compatibility (can be removed after migration)
      comingSoon: 'Coming Soon',
      error: 'Error',
      retry: 'Retry',
      status: 'Status',
    },
    
    // Agencies page translations
    agenciesPage: {
      searchAgencies: 'Search agencies by name or city...',
      allCities: 'All Cities',
      agencyFound: 'agency found',
      agenciesFound: 'agencies found',
      carsAvailable: 'Cars',
      locations: 'Locations',
      viewDetails: 'View Details',
      noAgenciesFound: 'No agencies found',
      adjustSearchCriteria: 'Try adjusting your search criteria or clear filters to see more results.',
      contactForHours: 'Contact for hours',
      varyingHours: 'Varying hours',
    },
  }
}; 